module.exports = __webpack_public_path__ + "static/img/refresh.98900f8d.png";